export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11282.3ad54b22.jpg";